import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { asField } from 'informed'
import { withApollo } from '@apollo/client/react/hoc'
import { Translation } from 'react-i18next'
import get from 'lodash/get'

import FixProdsSelect from './FixProdsSelect'
import { DataTable } from 'components/DataTable'
import { selectionProduct } from '../../../tableColumns'
import { Number as NumberInput } from 'components/forms'
import { WarningModal } from 'components/Modal'
import Button from 'components/Button'
import Divider from 'components/Divider'

import './FixProdsDetails.scss'

const FixProdsDetails = asField(({ fieldState: { value = [] }, fieldApi, selectedCategory, client, onFieldChange }) => (
	<FixProdsView
		fixProducts={value}
		onSubmitData={vals => {
			fieldApi.setValue(vals)
			if(typeof onFieldChange === 'function') {
				onFieldChange()
			}
		}}
		selectedCategory={selectedCategory}
		key={selectedCategory}
		client={client} />
))

class FixProdsView extends Component {
	state = {
		selectedProd: null,
		mutatedData: null,
		warningModalText: null
	}

	defaultValsFixProd = {
		amount: 1
	}

	handleSelectProd = selectedId => {
		const selectedProd = this.props.fixProducts.find(({ id }) => id === selectedId)
		this.setState({ mutatedData: selectedProd, selectedProd: selectedId })
	}

	clearMutatedData = (e) => this.setState({ mutatedData: {}, selectedProd: null })

	handleChangeProd = e => {
		e.preventDefault()
		const { fixProducts } = this.props,
			{ mutatedData, selectedProd } = this.state
		const newFixProd = { ...mutatedData, price: Number(mutatedData.price) || null }
		const newVals = selectedProd > -1
			? fixProducts.map(item => item.id === selectedProd ? newFixProd : item)
			: [...fixProducts, newFixProd]

		this.props.onSubmitData(newVals)
		this.clearMutatedData()
	}

	handleDelProd = (id) => {
		const newVals = this.props.fixProducts.filter(item => item.id !== id)
		this.props.onSubmitData(newVals)
		if(this.state.selectedProd === id) {
			this.clearMutatedData()
		}
	}

	openNewProdForm = t => e => {
		e.stopPropagation()
		if(this.props.selectedCategory) {
			if(this.state.selectedProd !== -1) {
				this.setState({ mutatedData: this.defaultValsFixProd, selectedProd: -1 })
			}
		} else {
			this.setState({ warningModalText: t('product_section.strings.select_template') })
		}
	}

	existingCheck = (val, allVals, t) => {
		const res = allVals.some(({ id }) => id === val)
		if(res) {
			this.setState({ warningModalText: t('product_section.strings.record_exists') })
		}
		return res
	}

	handleChangeNum = fieldName => v => {
		/* 'v' can be event object or a string represented value depending on what is caused onChange -
		input typing or a click on increment/decrement buttons */
		const value = get(v, 'target.value', v)
		this.setState({ mutatedData: { ...this.state.mutatedData, [fieldName]: Number(value) } })
	}

	render({ fixProducts = [], onSubmitData, selectedCategory } = this.props) {
		const { selectedProd, mutatedData, warningModalText } = this.state

		return(
			<Translation>
				{t => (
					<Row>
						<Col xs={6} className='table-fixed-products'>
							<DataTable
								data={fixProducts}
								columns={selectionProduct(t)}
								withSearch
								selectRow
								onRowClick={(state, { original: { id } }) => this.handleSelectProd(id)}
								mutateRow={{
									onRowMutate: this.handleDelProd
								}}
								minRows={0}
								className='table-fixed-products'
								onAddRecord={this.openNewProdForm(t)}
							/>
							<Divider />
						</Col>
						<Col xs={6}>
							{(selectedProd || selectedProd === 0) &&
								<Fragment>
									<FixProdsSelect
										value={{ id: mutatedData.id, name: mutatedData.name }}
										onChange={({ id, name, code }) => {
											const isAlreadyExists = this.existingCheck(id, fixProducts, t)
											if(!isAlreadyExists) {
												this.setState({ mutatedData: { ...mutatedData, id, name, code } })
											}
										}}
										categoryId={selectedCategory}
									/>
									<Col type='row'>
										<NumberInput
											noForm
											shrink
											inline
											withControls={false}
											value={mutatedData.amount || mutatedData.amount === 0 ? mutatedData.amount : 1}
											onChange={this.handleChangeNum('amount')}
											field='amount'
											label={t('common.fields.quantity')}
										/>
										<NumberInput
											noForm
											shrink
											inline
											withControls={false}
											value={mutatedData.price}
											onChange={this.handleChangeNum('price')}
											field='price'
											label={t('product_section.strings.price')}
											format='currency'
											toFixed={2}
											precision={2}
										/>
									</Col>
									<Col type='row'>
										<Button
											size='small'
											shrink={true}
											// text={selectedProd === -1 ? 'hinzufügen' : 'speichern'}
											text={t(`common.buttons.${selectedProd === -1 ? 'add' : 'save'}`)}
											status={mutatedData.id ? 'primary' : 'inactive'}
											onClick={this.handleChangeProd} />
										<Button shrink={true} text={t('common.buttons.cancel')} status='cancelation' onClick={this.clearMutatedData} />
									</Col>
								</Fragment>
							}
						</Col>
						{warningModalText &&
							<WarningModal
								label='Information'
								text={warningModalText}
								onClose={() => this.setState({ warningModalText: null })} />}
					</Row>
				)}
			</Translation>
		)
	}
}

FixProdsDetails.propTypes = {
	field: PropTypes.string.isRequired,
	selectedCategory: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	])
}

export default withApollo(FixProdsDetails)
